import React from 'react';
import { LandingPage } from './pages';
import { Header } from './components';
import './App.scss';
import './styles/Fonts.scss';
import './styles/Commonstyle.scss';
import './styles/Flexboxstyle.scss';
import { Footer } from './components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Header/>

      <div className="application-content">
        <LandingPage/>
      </div>

      <Footer/>
    </div>
  );
}

export default App;
